'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'swap';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e609';
var svgPathData = 'M28.4 158.2l35.6 0 0 193.8c0 70.7 57.3 128 128 128s128-57.3 128-128l0-192c0-35.3 28.7-64 64-64s64 28.7 64 64l0 192-35.6 0c-15.7 0-28.4 12.7-28.4 28.4 0 7.5 3 14.8 8.3 20.1L463 471.2c9.4 9.4 24.6 9.4 33.9 0l70.7-70.7c5.3-5.3 8.3-12.6 8.3-20.1 0-15.7-12.7-28.4-28.4-28.4l-35.6 0 0-192c0-70.7-57.3-128-128-128S256 89.3 256 160l0 192c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-193.8 35.6 0c15.7 0 28.4-12.7 28.4-28.4 0-7.5-3-14.8-8.3-20.1L113 39c-9.4-9.4-24.6-9.4-33.9 0L8.3 109.7C3 115.1 0 122.3 0 129.8 0 145.5 12.7 158.2 28.4 158.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSwap = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;